import type { SVGProps } from 'react'

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M19.5078 13.2421C19.5078 13.0929 19.4632 12.947 19.3798 12.8232C19.2964 12.6994 19.178 12.6033 19.0397 12.5472C18.9014 12.4911 18.7494 12.4776 18.6034 12.5083C18.4573 12.539 18.3237 12.6126 18.2197 12.7197L12.5 18.4394L12.5 3.74994C12.5014 3.65056 12.483 3.55188 12.446 3.45966C12.4089 3.36743 12.3539 3.28349 12.2841 3.21271C12.2143 3.14194 12.1312 3.08573 12.0395 3.04737C11.9478 3.00901 11.8494 2.98926 11.75 2.98926C11.6506 2.98926 11.5522 3.00901 11.4605 3.04737C11.3688 3.08573 11.2857 3.14194 11.2159 3.21271C11.1461 3.28349 11.0911 3.36743 11.054 3.45966C11.017 3.55188 10.9986 3.65056 11 3.74994L11 18.4394L5.28027 12.7197C5.21116 12.6477 5.12839 12.5902 5.03679 12.5506C4.9452 12.511 4.84662 12.4901 4.74684 12.4891C4.64706 12.4881 4.54808 12.507 4.4557 12.5447C4.36332 12.5824 4.27939 12.6382 4.20883 12.7088C4.13828 12.7793 4.08251 12.8633 4.04479 12.9556C4.00707 13.048 3.98817 13.147 3.98918 13.2468C3.9902 13.3466 4.01111 13.4451 4.0507 13.5367C4.09028 13.6283 4.14775 13.7111 4.21973 13.7802L11.2197 20.7802C11.3604 20.9208 11.5511 20.9998 11.75 20.9998C11.9489 20.9998 12.1396 20.9208 12.2803 20.7802L19.2803 13.7802C19.3523 13.7103 19.4095 13.6267 19.4486 13.5342C19.4877 13.4418 19.5078 13.3425 19.5078 13.2421Z"
			fill="currentColor"
		/>
	</svg>
)
